/**
 * 用於顯示右下角通知的 Vue 插件。
 * 此插件會在 Vue 的原型上安裝全域的 `$bottomRightToast` 方法，
 * 讓元件可以觸發通知訊息。
 *
 * @module bottomRightToast
 */
import Vue from 'vue'
import BottomRightToastContainer from '@/components/BottomRightToast/BottomRightToastContainer'

/**
 * 安裝右下角通知插件。
 *
 * @property {Function} Vue.prototype.$bottomRightToast - 用於顯示通知訊息的方法。
 * @param {Object} options - 通知訊息的選項。
 * @param {string} options.title - 通知訊息的標題。
 * @param {string} options.content - 通知訊息的內容。
 * @param {string} options.link - 點擊訊息所導向的連結。
 */
const ToastConstructor = Vue.extend(BottomRightToastContainer)
export default {
  install (Vue) {
    const instance = new ToastConstructor()
    document.body.appendChild(instance.$mount().$el)
    Vue.prototype.$bottomRightToast = function ({ title, content, link }) {
      instance.addMessage({ title, content, link })
    }
  }
}
